<template>
  <div class="standardized-dropdown">
    <label :for="id">{{ label }}</label>
    <select 
      :id="id"
      v-model="selectedValue"
      @change="updateValue"
      class="dropdown-select"
      :disabled="disabled"
    >
      <option disabled value="">{{ placeholder }}</option>
      <option v-for="(option, index) in options" :key="index" :value="option">
        {{ option }}
      </option>
    </select>
    <div v-if="validationMessage" class="validation-message">
      {{ validationMessage }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'StandardizedDropdown',
  props: {
    value: {
      type: String,
      default: ''
    },
    options: {
      type: Array,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    id: {
      type: String,
      required: true
    },
    placeholder: {
      type: String,
      default: 'Select an option'
    },
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    validationRules: {
      type: Function,
      default: null
    },
    // New prop to enforce validation against standardized options
    enforceStandardOptions: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      selectedValue: this.value,
      validationMessage: ''
    };
  },
  watch: {
    value(newVal) {
      this.selectedValue = newVal;
    }
  },
  methods: {
    updateValue() {
      this.$emit('input', this.selectedValue);
      this.validate();
    },
    validate() {
      this.validationMessage = '';
      
      // Basic required validation
      if (this.required && !this.selectedValue) {
        this.validationMessage = `${this.label} is required`;
        return false;
      }
      
      // Enforce standard options validation
      if (this.enforceStandardOptions && this.selectedValue) {
        if (!this.options.includes(this.selectedValue)) {
          this.validationMessage = `${this.selectedValue} is not a valid option for ${this.label}`;
          return false;
        }
      }
      
      // Custom validation if provided
      if (this.validationRules && this.selectedValue) {
        const result = this.validationRules(this.selectedValue);
        if (!result.isValid) {
          this.validationMessage = result.message;
          return false;
        }
      }
      
      return true;
    }
  }
};
</script>

<style scoped>
.standardized-dropdown {
  margin-bottom: 10px;
}

label {
  display: block;
  margin-bottom: 5px;
  font-weight: bold;
}

.dropdown-select {
  width: 100%;
  padding: 5px;
  border: 1px solid #ccc;
  border-radius: 3px;
}

.validation-message {
  color: red;
  font-size: 0.8em;
  margin-top: 3px;
}
</style>